import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import { ArrowRight } from "lucide-react";
import { PHOTO_STORY } from "@/lib/postEvent";

const fade = { initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } };

// Group photos by theme, preserving order.
const THEMES = PHOTO_STORY.reduce((acc, p) => {
  (acc[p.theme] = acc[p.theme] || []).push(p);
  return acc;
}, {});

export default function Highlights() {
  return (
    <Layout>
      <section className="bg-[#0A0A0A] text-white" data-testid="highlights-hero">
        <div className="container-summit py-20 md:py-28">
          <motion.div {...fade}>
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#C9B792]">Event Recap · September 11, 2026</div>
            <h1 className="serif text-4xl sm:text-6xl mt-6 leading-tight">The Experience,<br />in photographs.</h1>
            <p className="mt-6 text-white/60 max-w-2xl leading-relaxed">
              A visual story of the inaugural Travel + Leisure Strategic Supplier Summit — from welcome and executive
              sessions to the Supplier Showcase, Business Matchmaking, and the relationships built across the day.
            </p>
            <p className="mt-4 text-sm text-[#C9B792]" data-testid="highlights-media-note">More photos and video highlights will be added as they become available.</p>
          </motion.div>
        </div>
      </section>

      {Object.entries(THEMES).map(([theme, photos], ti) => (
        <section key={theme} className={ti % 2 ? "bg-zinc-50" : "bg-white"} data-testid={`highlights-theme-${ti}`}>
          <div className="container-summit py-16 md:py-24">
            <motion.div {...fade} className="mb-10">
              <div className="overline text-[#A39171]">{`0${ti + 1}`.slice(-2)}</div>
              <h2 className="serif text-3xl md:text-4xl mt-3">{theme}</h2>
            </motion.div>
            <div className="grid md:grid-cols-2 gap-6 md:gap-8">
              {photos.map((p, i) => (
                <motion.figure key={p.src} {...fade}
                  className={`overflow-hidden bg-zinc-100 ${photos.length % 2 === 1 && i === 0 ? "md:col-span-2" : ""}`}>
                  <img src={p.src} alt={p.caption} loading="lazy"
                    className={`w-full object-contain ${photos.length % 2 === 1 && i === 0 ? "h-[320px] md:h-[520px]" : "h-[280px] md:h-[380px]"}`} />
                  <figcaption className="mt-3 text-xs text-zinc-500 tracking-wide">{p.caption}</figcaption>
                </motion.figure>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="bg-[#0A0A0A] text-white" data-testid="highlights-footer-cta">
        <div className="container-summit py-16 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
          <h3 className="serif text-2xl md:text-3xl">Explore the outcomes behind the day.</h3>
          <div className="flex gap-3">
            <Link to="/impact" className="btn-gold" data-testid="highlights-cta-impact">View Event Impact <ArrowRight size={15} /></Link>
            <Link to="/survey" className="btn-outline-white" data-testid="highlights-cta-survey">Complete Survey</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
